/**
 * Page-level i18n namespace for the verification route. Primary copy lives in
 * `VerificationIntro.strings.ts` and `VerificationFlowForm.strings.ts`.
 */
export const kratos_verification = {};
